
define('text!common/views/sport/score-container.html',[],function () { return '<div class="score-container">\n    <div class="score__loading <%=loadingState%>">\n        <div class="loading__text">Fetching the scores…</div>\n        <div class="is-updating"></div>\n    </div>\n</div>';});

